import qrcode from "qrcode-generator";

/**
 * Renders text as an SVG QR code, scaled to `size` pixels. Error correction M by default; the
 * guardian pass uses L: at 550 characters that is a 73-module code instead of 85, so each square
 * is about 16% bigger for the door tablet's fixed-focus camera, and a phone screen is not torn.
 */
/** `quiet`: the white border in modules. 4 is the standard; 2 is enough for a phone reading a screen. */
export function QrCode({ text, size = 240, label, ecc = "M", quiet = 4 }: { text: string; size?: number; label: string; ecc?: "L" | "M"; quiet?: number }) {
  const qr = qrcode(0, ecc);
  qr.addData(text);
  qr.make();
  const n = qr.getModuleCount();
  let d = "";
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c + quiet} ${r + quiet}h1v1h-1z`;
  const total = n + quiet * 2;
  return (
    <svg role="img" aria-label={label} viewBox={`0 0 ${total} ${total}`} width={size} height={size} shapeRendering="crispEdges" style={{ background: "#fff", borderRadius: 8 }}>
      <path d={d} fill="#000" />
    </svg>
  );
}
